import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import LibraryProcessMapsGrid from './LibraryProcessMapsGrid';

const LibraryProcessMapsGridBridge = react2angular(LibraryProcessMapsGrid, []);

export default LibraryProcessMapsGridBridge;
